module.exports = __webpack_public_path__ + "static/media/compromisodepago.f63c3d70.png";